export default "__VITE_ASSET__CayPE5VA__"